import { jsx as _jsx } from "react/jsx-runtime";
import { getFuncionalidades } from '../../../api';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import GridBase from '../../../components/grid_base';
var COLUNAS = [
    { field: 'nome', headerName: 'Nome', width: 400 },
    { field: 'rota', headerName: 'Rota', width: 300 },
    { field: 'situacao', headerName: 'Situação', width: 150 },
];
export default function Funcionalidades() {
    return (_jsx(GridBase, { pagina: PAGINAS.FUNCIONALIDADES, paginaPermissao: FUNCIONALIDADES.FUNCIONALIDADES, rota: ROUTES.FUNCIONALIDADES, fetchData: function (str, _filter, pag) { return getFuncionalidades(str, pag); }, columns: COLUNAS, pagination: { page: 0, pageSize: 100 } }));
}
